<template>
  <div class="w-button-group" :class="componentClasses" :style="buttonSpace">
    <slot />
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';

import { defaults } from '../../composables/defaults';
import { withButtonGroupVariantProps, useButtonGroupVariantProps } from '../../composables/props/buttonGroupVariant';
import { withColorProps, useColorProps } from '../../composables/props/colors';
import { withRadiusProps, useRadiusProps } from '../../composables/props/radius';

// @vuese
// Komponent do grupowania przycisków
export default defineComponent({
  props: {
    ...withColorProps(defaults.button.color),
    ...withRadiusProps,
    ...withButtonGroupVariantProps,

    /** Odstępy pomiędzy przyciskami */
    space: {
      type: Number,
      default: defaults.buttonGroup.space
    },

    /** Czy łączyć przyciski  */
    connect: {
      type: Boolean,
      default: defaults.buttonGroup.connect
    }
  },

  setup(props) {
    const componentName = 'w-button-group';

    const buttonSpace = computed(() => {
      return `gap: ${props.space}px`;
    });

    /** Wyliczone klasy komponentu */
    const buttonGroupVariantClasses = useButtonGroupVariantProps(componentName, props);
    const colorClasses = useColorProps(componentName, props);
    const radiusClasses = useRadiusProps(componentName, props);

    const componentClasses = computed(() => {
      return [
        buttonGroupVariantClasses.value,
        colorClasses.value,
        radiusClasses.value,
        { 'w-button-group--connect': props.space === 0 && props.connect }
      ];
    });

    return { componentClasses, buttonSpace };
  }
});
</script>
<style lang="scss">
@use 'WButtonGroup';
</style>
